import React from 'react'
import {useIntl} from 'react-intl'
import styled from '@emotion/styled'

import {Box} from '@vio/atlas/helpers/Box'
import {Button} from '@vio/atlas/src/components/designSystem/Button'
import {Divider} from '@vio/atlas/src/components/designSystem/Divider'
import {Icon} from '@vio/atlas/src/components/designSystem/Icon'
import {InputText} from '@vio/atlas/src/components/designSystem/InputText'

import {hasReachedDailyMessageLimit} from './utils'

interface Props {
  inputValue: string
  onSubmit: () => void
  handleInputChange: (value: string) => void
}

const ButtonBox = styled(Box)`
  flex: 1;
  display: flex;
  align-items: stretch;
`

export const HotelQuestionFooter = ({
  inputValue,
  onSubmit,
  handleInputChange
}: Props) => {
  const {formatMessage} = useIntl()

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault()
      onSubmit()
    }
  }

  return (
    <>
      <Divider />
      <Box padding="s500" display="flex" gap="s400">
        <InputText
          disabled={hasReachedDailyMessageLimit()}
          id="chatBotInput"
          name="chatBotInput"
          label={formatMessage({
            defaultMessage: 'Ask a question',
            id: 'chatbot.askQuestionButton'
          })}
          value={inputValue}
          onChange={handleInputChange}
          customProps={{
            onKeyDown: handleKeyDown
          }}
        />

        <ButtonBox>
          <Button
            onClick={onSubmit}
            fullWidth
            size="lg"
            iconEnd={<Icon name="Telegram" />}
          />
        </ButtonBox>
      </Box>
    </>
  )
}
